import { Injectable, Inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromweeklySummary from './weekly-summary.actions';
import { switchMap, map, tap, catchError } from 'rxjs/operators';
import { TimeCardService } from '../time-card.service';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromShared from '../../shared';
@Injectable()
export class WeeklySummaryEffects {
    constructor(
        private actions$: Actions,
        @Inject(TimeCardService) private service: TimeCardService,
        @Inject(LoggingService) private log: LoggingService
    ) {}

    getWeeklySummary$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromweeklySummary.getWeeklySummary),
            tap(a =>
                this.log.verbose({ type: 'TimeCardEffects:getTimeCards$', a })
            ),
            switchMap(a =>
                this.service.getWeeklySummary(a.EmployeeListID, a.DRListID, null, a.StartDate, a.EndDate).pipe(
                    map(ws =>
                        fromweeklySummary.loadWeeklySummarys({
                            weeklySummarys: ws
                        })
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );
}
